export const BookingPrePaymentState = {
    AUTHORIZATION_HOLD: 'In Progress',
    AWAITING_AUTHORIZATION: `Wait for 3DS`,
    COMPLETED: `Paid`,
    CANCELED: `Canceled`,
    REJECTED: `Rejected`,
    REFUNDED: `Refunded`,
    REFUND_INITIATED: `Refund initiated`,
    REFUND_REJECTED: `Refunded rejected`,
};

export const BookingStatus = {
    REQUEST_CONFIRMED: 'Confirmed',
    REQUEST_RECEIVED: `Received`,
    RESERVED: `Reserved`,
    POSTPAID_CANCELED: `Postpaid canceled`,
    PREPAID_CANCELLED: `Prepaid canceled`,
    REJECTED: `Rejected`,
}